import React from "react";
import { Alert, Button, Form } from 'react-bootstrap';
import { renderField } from '../common/FormsControls.jsx';
import { email, required } from '../../../_utils/validators';
import { Field, reduxForm } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


const LoginForm = (props) => {
  const { anyTouched, invalid, submitting, handleSubmit, error } = props;
  return <Form onSubmit={ handleSubmit } className={ anyTouched ? 'was-validate' : '' }>
      <Row>
        <Col xs={12} md={6}>
          <Field component={ renderField }
                     element='input'
                     required='required'
                     name='username'
                     validate={ [required, email] }
                     label={ gettext('Адрес электронной почты') }
                     placeholder={ gettext('Адрес электронной почты') }
                  />
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <Field placeholder={ 'Password' }
                    type={ 'password' }
                    component={ renderField }
                    name={ 'password' }
                    label={ gettext('Пароль') }
                    placeholder={ gettext('Пароль') }
                    validate={ [required] }/>
        </Col>
      </Row>
      { error && <Alert variant="danger">{ error }</Alert> }
      <div className='mt-3'>
        <Button variant="orange" type="submit" disabled={ submitting || invalid }>
          { gettext('Войти') }
        </Button>
      </div>
    </Form>
}

export default compose(
  // connect(mapStateToProps,{ }),
  reduxForm({ form: 'loginForm' })
)(LoginForm);
